import { Component } from '@angular/core';
import { SpThemingService } from '../../../services/sp-theming/sp-theming.service';
import {ImageType} from '../sp-page-error/sp-page-error.component';
import {Router} from '@angular/router';

@Component({
  selector: 'app-sp-page-access-denied',
  templateUrl: './sp-page-access-denied.component.html'
})
export class SpPageAccessDeniedComponent {
  protected readonly ImageType = ImageType;

  // Constructor.
  constructor(
    private _spTheming: SpThemingService,
    private router: Router
  ) {
    // Set the theme to use.
    this._spTheming.setSpThemeName('dashboard-default');
  }

  async onButtonClick() {
    await this.router.navigate(['/']);
  }
}
